


























































































































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting from '@/classes/siteSetting';
import SaveItem from './SaveItem.vue';

export default Vue.extend({
  components: { SaveItem },
  name: 'SaveDataView',
  props: {
    rootData: {
      type: SaveData,
      required: true,
    },
    handleInform: {
      type: Function,
      required: true,
    },
    enabledFixDrawer: {
      type: Boolean,
      default: false,
    },
    fixedDrawer: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    editDialog: false,
    editedName: '',
  }),
  watch: {
    editDialog(value) {
      if (value) {
        setTimeout(() => {
          (this.$refs.nameInput as HTMLInputElement).focus();
        }, 150);
      }
    },
    fixedDrawer(value) {
      if (value) {
        document.body.classList.add('drawer-fixed');
      } else {
        document.body.classList.remove('drawer-fixed');
      }
    },
  },
  computed: {
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
  },
  methods: {
    textFieldFocused(focusEvent: FocusEvent) {
      if (focusEvent) (focusEvent.target as HTMLInputElement).select();
    },
    addNewFile() {
      // 新規データ
      const data = new SaveData();
      data.name = `${this.$t('SaveData.新規データ')}`;
      data.isUnsaved = false;
      this.addNewSaveData(data);
    },
    showDirectoryNameEditDialog() {
      this.editedName = `${this.$t('SaveData.新しいフォルダー')}`;
      this.editDialog = true;
    },
    addNewDirectory() {
      if (this.isNameEmpty) {
        return;
      }
      this.editDialog = false;

      // 新規フォルダー
      const folder = new SaveData();
      folder.name = this.editedName;
      folder.isDirectory = true;
      folder.isUnsaved = false;
      folder.color = 'yellow lighten-1';
      folder.order = 999999;
      this.addNewSaveData(folder);
      this.handleInform('新しいフォルダーを作成しました。');

      this.editedName = '';
    },
    addNewSaveData(saveData: SaveData) {
      saveData.order = 999999;
      const data = this.rootData.childItems;
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].addNewFileToSelectedData(saveData)) {
          // セーブデータの更新を通知
          this.$store.dispatch('updateSaveData', this.rootData);
          this.handleInform(`新しい${saveData.isDirectory ? 'フォルダー' : '編成'}を作成しました。`);
          return;
        }
      }

      // 最後まで選択状態ファイルが見つからなければ、保存されたデータの直下いき
      const folder = this.rootData.childItems.find((v) => v.isDirectory);
      if (folder) {
        if (!saveData.isDirectory) {
          saveData.name = folder.getNewSaveDataName();
          saveData.name = saveData.name.replace('新規データ', `${this.$t('SaveData.新規データ')} `);
        }
        folder.isOpen = true;
        folder.childItems.push(saveData);
        folder.sortChild();
        // セーブデータの更新を通知
        this.$store.dispatch('updateSaveData', this.rootData);
        this.handleInform(`新しい${saveData.isDirectory ? 'フォルダー' : '編成'}を作成しました。`);
      }
    },
    openAllDirectory() {
      this.rootData.openDirectory();
    },
    closeAllDirectory() {
      this.rootData.closeDirectory();
    },
    deleteChild(index: number) {
      this.rootData.childItems = this.rootData.childItems.filter((v, i) => i !== index);
      this.handleInform('削除が完了しました。');
      // セーブデータの更新を通知
      this.$store.dispatch('updateSaveData', this.rootData);
    },
    openGitHub() {
      window.open('https://github.com/noro6/kc-web/', '_blank');
    },
    toggleFixDrawer() {
      const setting = this.$store.state.siteSetting as SiteSetting;
      setting.fixedDrawer = !setting.fixedDrawer;
      this.$store.dispatch('updateSetting', setting);
    },
  },
});
